var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"init",staticStyle:{"display":"hidden"}})
}
var staticRenderFns = []

export { render, staticRenderFns }